import React, { lazy, Suspense, useState } from 'react';
import { UploaderLoader } from 'components/shared/UniversalUploader/UploaderLoader';
import ConditionalWrapper from '../ConditionalWrapper';
import { UploaderModal } from './UploaderModal';

const SeismicUniversalUploader = lazy(() =>
  import(/* webpackChunkName: "UUC" */ './Uploader'),
);

// temporarily used to lo lazy load the uploader component since there's an outstanding issue lazy loading @seismic/universal-upload-component directly
const UniversalUploader = ({
  uploaderId,
  accept,
  onComplete,
  onFileError,
  onDelete,
  readOnly,
  showImageLibrary,
  helperText,
  deleteUploadRecord,
  displayInModal,
  modalShown,
  onModalDismiss,
  maxSize,
}) => {
  const [disableDismiss, setDisableDismiss] = useState(false);

  return (
    <ConditionalWrapper
      condition={displayInModal}
      wrapper={children => (
        <UploaderModal
          onDismiss={onModalDismiss}
          shown={modalShown}
          disableDismiss={disableDismiss}
        >
          {children}
        </UploaderModal>
      )}
    >
      <Suspense fallback={<UploaderLoader />}>
        <SeismicUniversalUploader
          uploaderFileId={uploaderId}
          accept={accept}
          onComplete={onComplete}
          onDelete={onDelete}
          onFileError={onFileError}
          readOnly={readOnly}
          showImageLibrary={showImageLibrary}
          helperText={helperText}
          deleteUploadRecord={deleteUploadRecord}
          maxSize={maxSize}
          setDisableDismiss={setDisableDismiss}
        />
      </Suspense>
    </ConditionalWrapper>
  );
};

export { UniversalUploader };
